import { Expose, Transform } from 'class-transformer';

export abstract class Model {
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  createdAt?: Date | null;
}
